class ZendeskWidgetUtil {
    static updateZIndex(zIndex) {
        if (this.isEnabled()) {
            try {
                window[this.zendeskInterfaceName]('messenger:set', 'zIndex', zIndex);
            }
            catch (error) {
                console.warn('Failed to update Zendesk widget zIndex:', error);
            }
        }
    }
    static resetZIndex() {
        if (this.isEnabled()) {
            try {
                window[this.zendeskInterfaceName]('messenger:set', 'zIndex', this.defaultZIndex);
            }
            catch (error) {
                console.warn('Failed to reset Zendesk widget zIndex:', error);
            }
        }
    }
    static isEnabled() {
        return !!window[this.zendeskInterfaceName];
    }
}
ZendeskWidgetUtil.zendeskInterfaceName = 'zE';
ZendeskWidgetUtil.defaultZIndex = 899;
export default ZendeskWidgetUtil;
